import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { COURSE_TYPE_NODE_FRAGMENT } from '../fragments'

const DELETE_COURSE_TYPE_MUTATION = gql`
  mutation deleteCourseType($id: ID!) {
    deleteCourseType(id: $id) {
      results {
        ...CourseTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${COURSE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_COURSE_TYPE_MUTATION
